import { WebClient } from "./server/WebClient";

export const TelemetryService = {
    updateContactField: (field: string, value: string) => WebClient.Put.Unvalidated<undefined>(`api/Telemetry/UpdateContact?field=${field}&value=${value}`, {}),
    recordSermonCountChange: () => WebClient.Put.Unvalidated<undefined>(`api/Telemetry/CountSermons`, {}),
    recordSermonSeriesCountChange: () => WebClient.Put.Unvalidated<undefined>(`api/Telemetry/CountSermonSeries`, {}),
    recordFolderCountChange: () => WebClient.Put.Unvalidated<undefined>(`api/Telemetry/CountFolders`, {}),
    recordSlideChange: () => WebClient.Put.Unvalidated<undefined>(`api/Telemetry/AddSlide`, {}),
    recordUserActivity: () => {
        try {
            let lastActiveStr = localStorage.getItem("lastActive");
            let lastActive = lastActiveStr ? new Date(lastActiveStr) : new Date(2000, 1, 1);
            let now = new Date();
            
            let millisecondsSinceLastActive = now.getTime() - lastActive.getTime();
            const FIVE_MINUTES = 5 * 60 * 1000;
    
            if (millisecondsSinceLastActive > FIVE_MINUTES) {
                localStorage.setItem("lastActive", now.toString());
                WebClient.Put.Unvalidated<undefined>(`api/Telemetry/UpdateContact?field=sc_cloud_interactiondate&value=${now.toString()}`, {});
            }
        } catch (error) {
            // If any errors are encountered with using local storage, do nothing
        }
    },
    checkForUserFirstAccess: () =>  WebClient.Put.Unvalidated<undefined>(`api/Telemetry/UserAccess`, {})
}